import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconBriefcase = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6663 5C9.37768 5 8.33301 6.04467 8.33301 7.33333V7.66675H7.33301C5.67615 7.66675 4.33301 9.00989 4.33301 10.6667V16.0001C4.33301 17.6569 5.67615 19.0001 7.33301 19.0001H16.6663C18.3232 19.0001 19.6663 17.6569 19.6663 16.0001V10.6667C19.6663 9.0099 18.3232 7.66675 16.6663 7.66675H15.6663V7.33333C15.6663 6.04467 14.6217 5 13.333 5H10.6663ZM13.6663 7.66675V7.33333C13.6663 7.14924 13.5171 7 13.333 7H10.6663C10.4822 7 10.333 7.14924 10.333 7.33333V7.66675H13.6663ZM10.333 9.66675H13.6663V17.0001H10.333V9.66675ZM8.33301 9.66675H7.33301C6.78072 9.66675 6.33301 10.1145 6.33301 10.6667V16.0001C6.33301 16.5524 6.78072 17.0001 7.33301 17.0001H8.33301V9.66675ZM15.6663 17.0001V9.66675H16.6663C17.2186 9.66675 17.6663 10.1145 17.6663 10.6667V16.0001C17.6663 16.5524 17.2186 17.0001 16.6663 17.0001H15.6663Z"
        />
      </svg>
    );
  }
);
